/**
 * Parámetros comerciales B2B de la home (HU-14).
 *
 * El mínimo de compra ya está acordado en vivo; el precio-referencia público
 * queda pendiente de que el negocio defina los valores por tramo (el detalle
 * completo viaja en el catálogo PDF gateado, no en la web).
 */

/** Mínimo de compra corporativo, en unidades. */
export const MIN_UNITS_B2B = 12;

/**
 * Precio-referencia público "desde $X por unidad". `null` hasta que se definan
 * los tramos; la UI degrada a mostrar solo el mínimo.
 */
export const PRICE_PER_UNIT_FROM: number | null = null;
